export default {
  title: 'Third-party invoices for supplementaries expenses',
  addSelected: 'Add selected'
}
